import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { TwoFactorCode } from './TwoFactorCode'

export const TwoFactorAuthentication: React.FC = () => (
  <Routes>
    <Route path="" element={<TwoFactorCode />} />
  </Routes>
)
